import { render, staticRenderFns } from "./ProfileConfiguration.vue?vue&type=template&id=3f5040f0"
import script from "./ProfileConfiguration.vue?vue&type=script&lang=js"
export * from "./ProfileConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports